import * as alertas from "./alertas.js";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';


export function init() {
  var video = document.getElementById('video_detail');
}
